define(function (require) {
    'use strict';

    var LE = require('app');
    var Constant = require("content-config/constant.json");
    var BaseRouterController = require("controllers/BaseRouterController");
    var ContentCannedEditController = require("content-controllers/canned/ContentCannedEditController");
    var ContentSystemEditController = require("content-controllers/system/ContentSystemEditController");
    var ContentSystemTabsController = require("content-controllers/system/ContentSystemTabsController");
    var ContentCannedTableController = require("content-controllers/canned/ContentCannedTableController");
    var ContentImportController = require("content-controllers/ContentImportController");
    var ContentImportErrorsController = require('content-controllers/ContentImportErrorsController');

    var TYPES = Constant.CONTENT_TYPES;
    //todo Decide when and where to fetch the content collections, category collection

    var ContentRouteController = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentRouteController = BaseRouterController.extend({
            contentCannedEditController: null,
            contentSystemEditController: null,
            contentSystemMessagingEditController: null,
            contentImportController: null,
            contentImportErrorsController: null,
            navigation:{
                routes: {
                    "content/system": {
                        callback:"contentSystemList",
                        name:"ContentSystemList",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "content/system/:id":{
                        callback: "editSystemMessage",
                        name:"EditSystemMessage",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "content/canned":{
                        callback: "contentCannedList",
                        name:"ContentCannedList",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "content/canned/:id":{
                        callback: "editCannedMessage",
                        name:"EditCannedMessage",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "content/canned/new/text":{
                        callback: "newCannedMessageText",
                        name:"NewCannedMessageText",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.ADD_CANNED]
                        }
                    },
                    "content/systemMessaging": {
                        callback:"contentSystemMessagingList",
                        name:"ContentSystemMessagingList",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    },
                    "content/systemMessaging/:id":{
                        callback: "editSystemMessagingMessage",
                        name:"EditSystemMessagingMessage",
                        hasSpecialNavigate: true,
                        auth: {
                            privileges: [LE.sessionManager.PRIVILEGES.LE_VIEW_CAMPAIGN_MODULE]
                        }
                    }
                },
                defaultRoute: "content/system",
                fallbackRoute: "LECampaigns"
            },

            initialize:function () {
                LEContent.logger.info("initialize","ContentRouteController");
                this.dataManager = LEContent.getDataManager();

                this.contentSystemTabsController = new ContentSystemTabsController();

                this.contentCannedEditController = new ContentCannedEditController({});
                this.contentSystemEditController = new ContentSystemEditController({type: TYPES.SYSTEM});

                this.contentCannedTableController = new ContentCannedTableController({});

                if (LEContent.context.get(LEContent.context.KEYS.hasContentImportPrivileges)) {
                    _.extend(this.navigation.routes, {
                        "content/canned/import": {
                            callback: "importCannedContent",
                            name:"ImportCannedContent",
                            hasSpecialNavigate: true,
                            auth: {
                                privileges: [LE.sessionManager.PRIVILEGES.CANNED_RESPONSES_IMPORT]
                            }
                        },
                        "content/canned/import/errors": {
                            callback: "importCannedContentErrors",
                            name:"ImportCannedContentErrors",
                            hasSpecialNavigate: true,
                            auth: {
                                privileges: [LE.sessionManager.PRIVILEGES.CANNED_RESPONSES_IMPORT]
                            }
                        }
                    });
                    this.contentImportController = new ContentImportController({});
                    this.contentImportErrorsController = new ContentImportErrorsController();
                }

                if (LE.sessionManager.hasEditMessagingAutoMessagesFeature() ) {
                    this.contentSystemMessagingEditController = new ContentSystemEditController({ type: TYPES.SYSTEM_MESSAGING });
                }
                else { // if there is no ac feature to edit the messaging feature - we should show the "privilege" error, so we mimic the functionality by putting a privilege that nobody has
                    this.navigation.routes["content/systemMessaging/:id"].auth.privileges = [LE.sessionManager.PRIVILEGES.PRIVILEGE_THAT_NOBODY_HAS];
                }

                this.navigation.defaultRoute = this.contentSystemTabsController.getFirstTabPath();
            },

            editSystemMessage: function(contentId) {
                LEContent.logger.debug("editSystemMessage called for content id: " + contentId ,"ContentRouteController:editSystemMessage");
                var deps = [
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: true}}
                ];

                this._fetchDependencies(deps,function () {
                    this._showView(this.contentSystemEditController);
                    this.contentSystemEditController.editSystemMessage({"contentId": contentId});
                });
            },
            editSystemMessagingMessage: function(contentId) {
                LEContent.logger.debug("editSystemMessagingMessage called for content id: " + contentId ,"ContentRouteController:editSystemMessagingMessage");
                if(! LE.sessionManager.hasEditMessagingAutoMessagesFeature()) {
                    LEContent.router.navigate(this.navigation.defaultRoute);
                    return;
                }

                var deps = [
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: true}},
                    {name: this.dataManager.getEntities().SYSTEM_MESSAGING_DEFAULTS, options: {isMandatory: true ,freshnessTime: 3600}}
                ];

                this._fetchDependencies(deps,function () {
                    this._showView(this.contentSystemMessagingEditController);
                    this.contentSystemMessagingEditController.editSystemMessage({"contentId": contentId});
                });
            },
            editCannedMessage: function(contentId) {
                LEContent.logger.debug("editCannedMessage called for content id: " + contentId ,"ContentRouteController:editCannedMessage");
                this._showView(this.contentCannedEditController);
                this.contentCannedEditController.editCannedMessage({"contentId": contentId});
            },
            newCannedMessageText: function(contentId) {
                LEContent.logger.debug("newCannedMessageText called for content id: " + contentId ,"ContentRouteController:newCannedMessageText");
                this._showView(this.contentCannedEditController);
                this.contentCannedEditController.newCannedMessageText();
            },
            contentSystemList: function() {
                LEContent.logger.debug("contentSystemList called " ,"ContentRouteController:contentSystemList");
                var deps = [
                    {name: this.dataManager.getEntities().SYSTEM, options: {isMandatory: true }},
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: false}}
                ];

                this._fetchDependencies(deps,function () {
                    this._showView(this.contentSystemTabsController);
                    this.contentSystemTabsController.showChatTab();
                });
            },
            contentSystemMessagingList: function() {
                LEContent.logger.debug("contentSystemMessagingList called " ,"ContentRouteController:contentSystemMessagingList");
                if(! LE.sessionManager.hasMessagingAutoMessagesFeature()) {
                    LEContent.router.navigate(this.navigation.defaultRoute);
                    return;
                }
                var deps = [
                    {name: this.dataManager.getEntities().SYSTEM_MESSAGING, options: {fetchOptions: { reset: true }, isMandatory: true }},
                    {name: this.dataManager.getEntities().SYSTEM_MESSAGING_DEFAULTS, options: {isMandatory: true ,freshnessTime: 3600}},
                    {name: this.dataManager.getEntities().SKILL, options: {isMandatory: false}}
                ];

                this._fetchDependencies(deps,function () {
                    this._showView(this.contentSystemTabsController);
                    this.contentSystemTabsController.showMessagingTab();
                });


            },
            contentCannedList: function() {
                LEContent.logger.debug("contentCannedList called " ,"ContentRouteController:contentCannedList");
                this._showView(this.contentCannedTableController);
                this.contentCannedTableController.loadCannedList();
            },
            importCannedContent: function () {
                LEContent.logger.info("importCannedContent called ", "ContentRouteController:importCannedContent");
                LEContent.getMainView().toggledMainRegion.add(this.contentImportController.getMainView());
                this.contentImportController.showImportCannedContent();
            },
            importCannedContentErrors: function () {
                LEContent.logger.info("importCannedContentErrors called ", "ContentRouteController:importCannedContentErrors");
                this._showView(this.contentImportErrorsController);
                this.contentImportErrorsController.showImportContentErrors();
            },
            _fetchDependencies: function(deps,successFunction){
                this.dataManager.getDependencies({
                    dependencies: deps,
                    success: _.bind(successFunction,this)
                });
            },
            _showView: function(controller, view) {
                if (this.currentController && _.isFunction(this.currentController.onNavigateOut)) {
                    this.currentController.onNavigateOut();
                }

                if (!view) {
                    view = controller.getMainView();
                }

                LEContent.getMainRegion().add(view);

                this.currentController = controller;
            }

        });
    });
    return ContentRouteController;
});

